import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link , useNavigate} from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import avatar1 from "../../assets/images/users/avatar-3.jpg";
import { createSelector } from 'reselect';
import { fetchUserAttributes } from 'aws-amplify/auth';
const ProfileDropdown = () => {
    const navigate = useNavigate();

    const selectDashboardData = createSelector(
        (state) => state.Profile,
        (user) => user.user
    );

    
    const user = useSelector(selectDashboardData);

    const [userName, setUserName] = useState("Admin");

    useEffect(() => {

       

        const getUserDeatails = async () => {
            try {
                const userAttributes = await fetchUserAttributes();
                const first_name = userAttributes['custom:firstname'];
                const last_name = userAttributes['custom:lastname'];
                
                setUserName(first_name);

            } catch (error) {
                // console.log(error.message);

                if (error.message === "User needs to be authenticated to call this API.") {
                    navigate("/logout");
                }

            }
        }
        getUserDeatails()
    }, [userName, user]);
    
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                           
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    

                    <DropdownItem className='p-0'>
                        <Link to="#" className="dropdown-item disabled">
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Help</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to="/change-password" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Change Password</span>
                        </Link>
                    </DropdownItem>

                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;